import {
  HHAlert,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import { useSnackbarContext } from '../../context/snackbar.context';
import {
  SubscriptionType,
  useGetBillsBySubscriptionIdQuery,
  useGetContractsV2Query,
} from '../../types';
import LoadingComponent from '../utils/loading';
import BillList from './bill-list';
import { BillSource } from './bill-types';

export interface BillsBySubscriptionIdProps {
  subscriptionData: SubscriptionType;
}

const BillsBySubscriptionId = ({
  subscriptionData,
}: BillsBySubscriptionIdProps): JSX.Element => {
  const { setSnackbarState } = useSnackbarContext();
  const { data, loading, error } = useGetBillsBySubscriptionIdQuery({
    variables: {
      source: BillSource.SUBSCRIPTIONS,
      sourceId: subscriptionData.id,
    },
  });
  const contractsQuery = useGetContractsV2Query({
    variables: {
      contractIds: [subscriptionData.contractId],
      includeVoided: true,
      page: 1,
      size: 100,
    },
  });

  const contractCurrency = contractsQuery.data?.getContractsV2?.items.find(
    ({ id }) => id === subscriptionData.contractId,
  )?.currency;

  if (loading) {
    return <LoadingComponent center />;
  }

  if (error) {
    return (
      <HHAlert
        hhVariant="outlined"
        severity="error"
        children={
          <HHTypography hhVariant="body">
            There was an error loading subscription bills
          </HHTypography>
        }
      ></HHAlert>
    );
  }

  if (!data || !data.getBillsBySubscriptionId) {
    return (
      <HHStack spacing={2} overflow="hidden">
        <HHTypography hhVariant="body">
          Subscription bills not found
        </HHTypography>
      </HHStack>
    );
  }

  if (!contractCurrency && !contractsQuery.loading) {
    setSnackbarState('Unable to load currency information', 'info', 3000);
  }

  return (
    <BillList
      billsData={data.getBillsBySubscriptionId}
      currency={contractCurrency || null}
    />
  );
};

export default BillsBySubscriptionId;
